export default __webpack_public_path__ + "static/media/technical_error.0aaecbf0.svg";